import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { FormattedHTMLMessage } from 'react-intl'
import { LocaleSwitch, ConfigurationFile, Image } from 'containers/misc'
import { Logo } from 'components/misc'
import styles from './header.styl'
import getHeaderColorStyle from 'helpers/getHeaderColorStyle'
import { CONFIGURATION_KEYS } from 'constants/enums'


const headerColorStyle = getHeaderColorStyle()

export default class Header extends Component {
  static propTypes = {
    className: PropTypes.string,
    isLocaleHidden: PropTypes.bool,
    logoUrl: PropTypes.string
  }

  render() {
    const { className, isLocaleHidden, logoUrl } = this.props

    return (
      <header
        className={`${styles.header} ${className && className}`}
        style={headerColorStyle}
      >
        <div className="container">
          <div className={styles.logo}>
            {logoUrl && <Image isPublic={true} src={logoUrl} alt="Participant Avatar" />}
            {!logoUrl && <Logo />}
          </div>
          {!isLocaleHidden &&
            <div className={styles.locale}>
              <LocaleSwitch />
            </div>}
          {false && <div className={`${styles.faq} hidden-xs`}>
            <ConfigurationFile
              configKey={CONFIGURATION_KEYS.faqDocuments.id}
              organizationId={1}
              isPublic
              formattedName={
                <FormattedHTMLMessage
                  id="label.frequently_asked_questions"
                  defaultMessage="Frequently asked questions"
                />
              }
              inline
            />
          </div>}
        </div>
        <div className={styles.separators}>
          <div className={styles.separator1} />
          <div className={styles.separator2} />
          <div className={styles.separator3} />
          <div className={styles.separator4} />
          <div className={styles.separator5} />
        </div>
      </header>
    )
  }
}
